/* Arcadia Health & MedSpa — arcadia.js */

// ── Navigation scroll behavior ──
(function () {
  const nav = document.getElementById('a-nav');
  if (!nav) return;
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });
})();

// ── Mobile nav burger ──
(function () {
  const burger = document.getElementById('a-navBurger');
  const mobile = document.getElementById('a-navMobile');
  if (!burger || !mobile) return;

  burger.addEventListener('click', () => {
    const isOpen = burger.classList.toggle('open');
    mobile.classList.toggle('open', isOpen);
    burger.setAttribute('aria-expanded', isOpen);
    mobile.setAttribute('aria-hidden', !isOpen);
  });

  mobile.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      burger.classList.remove('open');
      mobile.classList.remove('open');
      burger.setAttribute('aria-expanded', false);
      mobile.setAttribute('aria-hidden', true);
    });
  });
})();

// ── Testimonials carousel ──
(function () {
  const track = document.getElementById('a-testimonialsTrack');
  const dotsContainer = document.getElementById('a-testimonialDots');
  const prevBtn = document.getElementById('a-prevTestimonial');
  const nextBtn = document.getElementById('a-nextTestimonial');
  if (!track) return;

  const cards = track.querySelectorAll('.a-testimonial-card');
  let perView = 3;
  let current = 0;
  let dots = [];

  function getPerView() {
    if (window.innerWidth < 600) return 1;
    if (window.innerWidth < 900) return 2;
    return 3;
  }

  function totalPages() { return Math.ceil(cards.length / perView); }

  function buildDots() {
    dotsContainer.innerHTML = '';
    dots = [];
    for (let i = 0; i < totalPages(); i++) {
      const btn = document.createElement('button');
      btn.className = 'a-dot' + (i === 0 ? ' active' : '');
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-label', `Page ${i + 1}`);
      btn.addEventListener('click', () => goTo(i));
      dotsContainer.appendChild(btn);
      dots.push(btn);
    }
  }

  function goTo(page) {
    perView = getPerView();
    const pages = totalPages();
    current = Math.max(0, Math.min(page, pages - 1));
    const cardWidth = cards[0].offsetWidth;
    const gap = 16;
    const offset = current * perView * (cardWidth + gap);
    track.style.transform = `translateX(-${offset}px)`;
    dots.forEach((d, i) => d.classList.toggle('active', i === current));
  }

  function prev() { goTo(current - 1); }
  function next() { goTo(current + 1); }

  prevBtn && prevBtn.addEventListener('click', prev);
  nextBtn && nextBtn.addEventListener('click', next);

  let touchStartX = 0;
  track.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
  track.addEventListener('touchend', e => {
    const dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 50) dx < 0 ? next() : prev();
  }, { passive: true });

  function init() { perView = getPerView(); buildDots(); goTo(0); }
  init();
  window.addEventListener('resize', () => { perView = getPerView(); buildDots(); goTo(0); });
})();

// ── Scroll-triggered fade-up animations ──
(function () {
  const targets = document.querySelectorAll(
    '.a-services-intro__text, .a-services-intro__media, ' +
    '.a-glass-skin__media, .a-glass-skin__text, ' +
    '.a-facial-card, ' +
    '.a-hormone-card, ' +
    '.a-iv__media, .a-iv__text, ' +
    '.a-testimonial-card, ' +
    '.a-explore__card, ' +
    '.a-contact__text, .a-contact__media, ' +
    '.a-facials__header, .a-hormone__header, .a-testimonials__header'
  );

  targets.forEach((el, i) => {
    el.classList.add('a-fade-up');
    el.style.transitionDelay = `${(i % 4) * 80}ms`;
  });

  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    targets.forEach(el => obs.observe(el));
  } else {
    targets.forEach(el => el.classList.add('in-view'));
  }
})();
